import { Box, Typography } from '@mui/material'
import MuiBreadcrumbs from '@mui/material/Breadcrumbs'
import { styled } from '@mui/material/styles'
import type { FC } from 'react'
import { Link } from 'react-router-dom'
import { t } from 'ttag'

export interface Breadcrumb {
  title: string
  link?: string
}

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.secondary,
  display: 'flex',
  alignItems: 'center',
  fontSize: 14
}))

const Breadcrumbs: FC<{ items: Breadcrumb[] }> = ({ items }) => {
  return (
    <div role="presentation">
      <MuiBreadcrumbs aria-label={t`Breadcrumbs`} sx={{ mb: 3 }}>
        {items.map(item => {
          const { title, link } = item
          if (link) {
            return (
              <StyledLink key={title} to={link}>
                <Typography fontSize={14} color="text.secondary">
                  {title}
                </Typography>
              </StyledLink>
            )
          } else {
            return (
              <Box key={title} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={14} color="text.primary">
                  {title}
                </Typography>
              </Box>
            )
          }
        })}
      </MuiBreadcrumbs>
    </div>
  )
}
export default Breadcrumbs
